import React from "react";
import SingleOperatorContent from "../components/opi/single-operator-content";

const SingleOperator = () => {
  return <SingleOperatorContent />;
};

export default SingleOperator;
